import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAiAuthorOrganizationProfileVariables = Types.Exact<{
  input: Types.AIAuthorOrganizationProfileInput;
}>;

export type RunAiAuthorOrganizationProfile = {
  aiAuthorOrganizationProfile: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'private' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAiAuthorOrganizationProfileDocument = gql`
  mutation RunAiAuthorOrganizationProfile($input: AIAuthorOrganizationProfileInput!) {
    aiAuthorOrganizationProfile(input: $input) {
      streamName
      streamId
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAiAuthorOrganizationProfileMutationFn = Apollo.MutationFunction<
  RunAiAuthorOrganizationProfile,
  RunAiAuthorOrganizationProfileVariables
>;

/**
 * __useRunAiAuthorOrganizationProfile__
 *
 * To run a mutation, you first call `useRunAiAuthorOrganizationProfile` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiAuthorOrganizationProfile` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiAuthorOrganizationProfile, { data, loading, error }] = useRunAiAuthorOrganizationProfile({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAiAuthorOrganizationProfile(
  baseOptions?: Apollo.MutationHookOptions<
    RunAiAuthorOrganizationProfile,
    RunAiAuthorOrganizationProfileVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RunAiAuthorOrganizationProfile,
    RunAiAuthorOrganizationProfileVariables
  >(RunAiAuthorOrganizationProfileDocument, options);
}
export type RunAiAuthorOrganizationProfileHookResult = ReturnType<
  typeof useRunAiAuthorOrganizationProfile
>;
export type RunAiAuthorOrganizationProfileMutationResult =
  Apollo.MutationResult<RunAiAuthorOrganizationProfile>;
export type RunAiAuthorOrganizationProfileMutationOptions = Apollo.BaseMutationOptions<
  RunAiAuthorOrganizationProfile,
  RunAiAuthorOrganizationProfileVariables
>;
export function mockRunAiAuthorOrganizationProfile({
  data,
  variables,
  errors,
}: {
  data: RunAiAuthorOrganizationProfile;
  variables?: RunAiAuthorOrganizationProfileVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAiAuthorOrganizationProfileDocument, variables },
    result: { data, errors },
  };
}
